'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import { DeferredRequestKey } from '~/constants/common/deferredRequests';
import TradeContext from '~/context/common/TradeContext';
import useCommitTrades from '~/hooks/common/services/useCommitTrades';
import type { TradesResult } from '~/server-props/vdp/getTrades';

export default function TradesDeferred({
  promise
}: {
  promise: Promise<TradesResult | undefined>;
}) {
  const { triggerFetchTrades } = useContext(TradeContext);
  const commit = useCommitTrades();

  const onResolve = useCallback(
    (data: TradesResult | undefined) => {
      if (data) {
        commit({
          selectedTrade: data.response.selectedTrade,
          trades: data.response.trades
        });
      } else {
        triggerFetchTrades();
      }
    },
    [commit, triggerFetchTrades]
  );

  return (
    <DeferredStreamBoundary
      deferredKey={DeferredRequestKey.Trades}
      onResolve={onResolve}
      promise={promise}
    />
  );
}
